import Navigation from './Components/Navigation/Navigation';
import Header from './Components/Header/Header';
import About from './Components/About/About';
import Footer from './Components/Footer/Footer';
import './App.scss';

function App() {
  return (
    <>
      <Navigation />
      <Header />
      <About />
      <Footer />
    </>
  );
}

export default App;
